<p-table [scrollable]="true" [size]="'small'" [value]="this.companies()" scrollHeight="flex">
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="name">{{ 'customer.name' | translate }}
        <p-sortIcon field="name"/>
      </th>
      <th pResizableColumn pSortableColumn="address">{{ 'entity.address' | translate }}
        <p-sortIcon field="address"/>
      </th>
      <th pResizableColumn pSortableColumn="taxIdentifierNumber">{{ 'customer.vat-number' | translate }}
        <p-sortIcon field="taxIdentifierNumber"/>
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template #body let-company>
    <tr (click)="onRowSelect(company)" class="cursor-pointer hover:bg-gray-50">
      <td>
        {{ company.name }}
        @if (!company.isActive) {
          <span
            class="ml-2 px-2 py-0.5 text-xs rounded bg-gray-200 text-gray-600">{{ 'customer.inactive' | translate }}</span>
        }
      </td>
      <td>{{ company.address }}</td>
      <td>{{ company.taxIdentifierNumber }}</td>
      <td class="flex justify-end gap-1">
        <elcia-button (onClick)="delete($event, company)" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
      </td>
    </tr>
  </ng-template>
</p-table>
